<template>
    <div :class="fieldErrors[id] ? 'error' : ''">
        <label class="block text-gray-700 text-sm font-semibold  mb-2" :for="id" v-if="label">{{label}}</label>
        <date-pick v-model="localValue"
                   @input="onInput"
                   :id="id"
                   class="w-full"
                   :selectableYearRange="selectableYearRange"
                   :inputAttributes="{
                       placeholder: placeholder,
                       readonly: true,
                       class: [classes(), fieldErrors[id] ? 'border-red-500' : '']
                   }"
        />
        <div v-if="fieldErrors[id]" class="text-red-500 text-xs italic">
            {{fieldErrors[id]}}
        </div>
    </div>
</template>

<script>
    import DatePick from 'vue-date-pick';

    export default {
        components: {
            DatePick,
        },
        data() {
            return {
                localValue: this.value
            }
        },
        props: {
            value: {},
            placeholder: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                required: true
            },
            label: {
                type: String
            },
            selectableYearRange: {
                type: Object,
                default: () => { return {from: 2020, to: 2030} },
            },
            fieldErrors: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            size: {
                type: String,
                default: 'md'
            },
        },
        methods: {
            onInput() {
                this.$emit('input', this.localValue);
            },
            classes() {
                let baseClasses = 'text-sm appearance-none block w-full text-gray-700 border border-gray-200 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500';
                let paddingMap = {
                    xs: 'py-1 px-2',
                    sm: 'py-2 px-3',
                    md: 'py-3 px-4',
                    lg: 'py-4 px-5',
                };
                let textSizesMap = {
                    xs: 'text-xs',
                    sm: 'text-sm',
                    md: 'text-base',
                    lg: 'text-lg',
                };

                let padding = paddingMap[this.size];
                let text = textSizesMap[this.size];
                let disabled = this.disabled ? 'text-gray-300 cursor-not-allowed' : 'bg-gray-200';

                return `${baseClasses} ${text} ${padding} ${disabled}`
            }
        },
        watch: {
            value: function (newValue) {
                this.localValue = newValue
            }
        }
    }
</script>
